import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentService } from '../services/payment.service';
import { DataService } from '@app/core/services/data.service';
import { dictionaryItems } from '@app/core/constants/dictionaryItems';
import { RoleService } from '@app/core/services/role.service';
import { Adb2cService } from '@app/blocks/adb2c/services/adb2c/adb2c.service';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
    selector: 'app-payment-balance-breakdown',
    imports: [ CommonModule ],
    templateUrl: './payment-balance-breakdown.component.html',
    styleUrl: './payment-balance-breakdown.component.scss',
})
export class PaymentBalanceBreakdownComponent implements OnInit, OnDestroy {
    config: any;
    breakdown: any;
    isLeaseholder: boolean = false;
    isSharedOwner: boolean = false;
    isNuvu: boolean = false;
    isPrs: boolean = false;

    breakdownVisible = false;
    offsetHeight = 0;
    dictionary: any;
    balanceText = "";

    private destroy$ = new Subject<void>();
    private userSubscription?: Subscription;

    constructor(private paymentService: PaymentService,
        private dataService: DataService,
        private adb2cService: Adb2cService,
        private roleService: RoleService) {
    }

    ngOnInit() {

        this.breakdownVisible = false;
        this.offsetHeight = 0;

        this.dataService.getDictionaryItems().pipe(takeUntil(this.destroy$)).subscribe({
            next: (response) => {
                this.dictionary = response;
                this.balanceText = this.dataService.getDictionaryItemByKeyAndLanguage(this.dictionary, dictionaryItems.viewBalanceBreakdown, "en-GB") ?? dictionaryItems.viewBalanceBreakdown;
            },
            error: (error) => {
                console.log(error);
            }
        });

        this.userSubscription = this.adb2cService.activeUser.asObservable().pipe(takeUntil(this.destroy$)).subscribe(user => {
            if (user && user.sub && user[ 'tenancy_reference' ]) {
                this.isLeaseholder = this.roleService.isLeaseholder(user);
                this.isSharedOwner = this.roleService.isSharedOwner(user);
                this.isNuvu = this.roleService.isNuvu(user);
                this.isPrs = this.roleService.isPrs(user);

                if (!this.isLeaseholder && !this.isSharedOwner && !this.isNuvu && !this.isPrs) {

                    this.paymentService.getChargesBreakdown(user[ 'tenancy_reference' ]!, 0).subscribe({
                        next: (response) => {
                            if (response && response.data) {
                                this.breakdown = response.data;

                            }
                        },
                        error: (error) => {
                            console.log(error);
                        }
                    });
                }
            }
        });
    }

    showBreakdown() {
        this.breakdownVisible = !this.breakdownVisible;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.userSubscription?.unsubscribe();
    }
}
